import { ChartTooltipItem, ChartData } from 'chart.js';
import { PIE_CHART_MAX_SLICE_COUNT } from '../../utils/constants';

export function percentTooltipLabel(
  tooltipItem: ChartTooltipItem,
  chart: ChartData,
): string | string[] {
  const { index } = tooltipItem;

  // ⚠️ Index can be 0, and 0 is falsy
  if (index !== undefined) {
    const value = chart.datasets![0].data![index];
    return `${chart.labels![index]}: ${value} %`;
  }

  return '';
}

export function decisionTooltipLabel(
  tooltipItem: ChartTooltipItem,
  chart: ChartData,
): string | string[] {
  const { index } = tooltipItem;

  // ⚠️ Index can be 0, and 0 is falsy
  if (index !== undefined) {
    const value = chart.datasets![0].data![index] || '';
    return `${chart.labels![index]}: ${value} décision${value > 1 ? 's' : ''}`;
  }

  return '';
}

export function mergeSlices(args: {
  data: Array<number>;
  labels: Array<string>;
}) {
  if (args.data.length <= PIE_CHART_MAX_SLICE_COUNT) {
    return { newData: args.data, newLabels: args.labels };
  }
  const newData: Array<number> = args.data.slice(
    0,
    PIE_CHART_MAX_SLICE_COUNT - 1,
  );
  const restData = args.data.slice(
    PIE_CHART_MAX_SLICE_COUNT - 1,
    args.data.length,
  );
  const otherSlice = restData.reduce((acc, curr) => acc + curr, 0);
  newData.push(otherSlice);
  const newLabels: Array<string> = args.labels.slice(
    0,
    PIE_CHART_MAX_SLICE_COUNT - 1,
  );
  newLabels.push('Autres');
  return { newData, newLabels };
}

type canClickType = { hasOther: boolean; index: number | null };

export function canClick({ hasOther, index }: canClickType) {
  const hasClickedInsideChart = index !== null;
  const hasNotClickedOnLastSlice =
    index !== null && index < PIE_CHART_MAX_SLICE_COUNT - 1;
  const isSliceClickable = !hasOther || hasNotClickedOnLastSlice;
  return hasClickedInsideChart && isSliceClickable;
}

export function getEntityIdUrlSearch(pageType: string) {
  if (pageType === 'enterprise') {
    return 'eid';
  }
  if (pageType === 'lawyer') {
    return 'lid';
  }
  if (pageType === 'lawFirm') {
    return 'oid';
  }
  return '';
}

export function generateColorRange(args: {
  baseH: number;
  minSL: number;
  maxSL: number;
  nb: number;
}) {
  const res = [];
  let fromMin = args.minSL;
  let fromMax = args.maxSL;
  const slice = (args.maxSL - args.minSL) / (args.nb - 1);
  for (let i = 0; i < args.nb; i++) {
    res.push(
      `hsl(${args.baseH}, ${Math.round(fromMax)}%, ${Math.round(fromMin)}%)`,
    );
    fromMin += slice;
    fromMax -= slice;
  }
  return res;
}

export function chartValuesNotAllZero(caseCounts: Array<number>) {
  return caseCounts.reduce((acc, val) => acc + val, 0) !== 0;
}
